import React, { useEffect } from "react";
import { Button, List, Typography } from "antd";
import styles from "./subscription.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SubscriptionMiddlewre from "../../store/Middlewares/SubsciptionMiddleware";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function SubscriptionHistory() {
  const { Text } = Typography;
  const data = [
    {
      id: 1,
      item: "Monthly Plan",
      status: "expired",
    },
    {
      id: 2,
      item: "Quarterly Plan",
      status: "expired",
    },
  ];

  useEffect(() => {
    getSubscriptionHistory();
    getLanguage();
  }, []);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const CreateSubscriptionHistoryList = useSelector(
    (state) => state.SubscriptionReducer.CreateSubscriptionHistoryList
  );
  const CreateSubscriptionHistoryPagination = useSelector(
    (state) => state.SubscriptionReducer.CreateSubscriptionHistoryPagination
  );

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const getSubscriptionHistory = () => {
    const data = {
      next_page_url: undefined,
    };
    dispatch(SubscriptionMiddlewre.getSubscriptionHistory(data));
  };

  const onPressLoadMore = () => {
    let data = {
      next_page_url: CreateSubscriptionHistoryPagination?.next_page_url,
    };
    dispatch(SubscriptionMiddlewre.getSubscriptionHistory(data));
  };

  const loadMore = CreateSubscriptionHistoryPagination?.next_page_url ? (
    <div
      style={{
        textAlign: "center",
        marginTop: 12,
        width: "90%",
        height: 32,
        lineHeight: "32px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button onClick={onPressLoadMore} className={styles.loadMore_button}>
        Load More
      </button>
    </div>
  ) : null;
  return (
    <div style={{ width: "100%" }}>
      <List
        dataSource={CreateSubscriptionHistoryList}
        footer={loadMore}
        renderItem={(item, index) => {
          let ExpireOn = moment(item?.plan?.created_at)
            .add(1, item?.plan?.interval_time)
            .diff(moment());

          let ExpiryDate = moment(item?.plan?.created_at)
            .add(1, item?.plan?.interval_time)
            .format("MM/DD/YYYY");
          let date = moment().format("MM/DD/YYYY");
          console.log("created_at", item?.plan?.created_at);
          console.log("interval_time", item?.plan?.interval_time);
          console.log("ExpireOn", ExpireOn);
          console.log("date", date);
          console.log("dateeeeeeeeeeee", moment().format("MM/DD/YYYY"));

          return (
            <div className={styles.histCont}>
              <div className={styles.histItem}>
                <div>
                  <p className={styles.planText}>{item?.plan?.package_name}</p>
                  <Text className={styles.statusText}>
                    {ExpireOn < 0 ? "Expired" : "Expire on " + ExpiryDate}
                  </Text>
                </div>
                <div>
                  {ExpireOn < 0 ? (
                    <Button
                      onClick={() =>
                        navigate("/subscription/AddCard/Payments", {
                          state: item?.plan,
                        })
                      }
                      type="primary"
                      className={styles.antdButton}
                    >
                      Re-Subscribe
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
}

export default SubscriptionHistory;
